<template>
  <div class="print" >
    <el-form
      ref="form"
      :model="sizeForm"
      label-width="110px"
      size="mini"
      method="POST"
      action="https://www.kdniao.com/External/PrintOrder.aspx"
    >
      <el-form-item>
        <el-input
          v-model="sizeForm.RequestData"
          readonly
          name="RequestData"
          type="hidden"
        ></el-input>
      </el-form-item>
      <el-form-item >
        <el-input
          v-model="sizeForm.EBusinessID"
          readonly
          name="EBusinessID"
           type="hidden"
        ></el-input>
      </el-form-item>
      <el-form-item >
        <el-input
          v-model="sizeForm.DataSign"
          readonly
          name="DataSign"
          type="hidden"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="sizeForm.IsPriview"
          readonly
          name="IsPriview"
          type="hidden"
        ></el-input>
      </el-form-item>
      <el-form-item label="发件人" style="margin-top: -3rem">
        <el-input
          v-model="sizeForm.name"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="发件人手机">
        <el-input
          v-model="sizeForm.sender_phone"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="发件地址">
        <el-input
          v-model="sizeForm.place"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人">
        <el-input
          v-model="sizeForm.receiver_s"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人电话">
        <el-input
          v-model="sizeForm.receiver_phone"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人省份">
        <el-input
          v-model="sizeForm.receiver_place_pro"
          readonly
        ></el-input>
      </el-form-item>
       <el-form-item label="收件人城市">
        <el-input
          v-model="sizeForm.receiver_place_city"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人区/县">
        <el-input
          v-model="sizeForm.receiver_place_town"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人详细地址">
        <el-input
          v-model="sizeForm.receiver_address"
          readonly
        ></el-input>
      </el-form-item>
      <el-form-item label="" style="text-align: right">
        <button
          type="submit"
          style="
            background-color: #409eff;
            border-radius: 5px;
            cursor: pointer;
            width: 1rem;
            color: white;
          "
        >
          打印
        </button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'Print',
  data () {
    return {

      sizeForm: {
        RequestData: '',
        EBusinessID: '',
        DataSign: '',
        IsPriview: '',
        name: '',
        sender_phone: '',
        place: '',
        receiver_s: '',
        receiver_phone: '',
        receiver_place_pro: '',
        receiver_place_city: '',
        receiver_place_town: '',
        receiver_address: '',
        id: ''
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.sizeForm.RequestData = this.$route.query.RequestData
    this.sizeForm.EBusinessID = this.$route.query.EBusinessID
    this.sizeForm.DataSign = this.$route.query.DataSign
    this.sizeForm.IsPriview = this.$route.query.IsPriview
    this.showPrintInfo(this.$route.query.id)
  },
  methods: {
    showPrintInfo (id) {
      this.$axios
        .get('api/expmanage/showprintinfo?id=' + id)
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            if (data.data.sender) {
              this.sizeForm.name = data.data.sender.username
            }
            this.sizeForm.sender_phone = data.data.sender_phone
            if (data.data.place) {
              this.sizeForm.place = data.data.place === 'JA' ? '静安' : '奉贤'
            }
            this.sizeForm.receiver_s = data.data.receiver_s
            this.sizeForm.receiver_phone = data.data.receiver_phone
            this.sizeForm.receiver_place_pro = data.data.receiver_place_pro
            this.sizeForm.receiver_place_city = data.data.receiver_place_city
            this.sizeForm.receiver_place_town = data.data.receiver_place_town
            this.sizeForm.receiver_address = data.data.receiver_address
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/exp_manage/print.vue